import React, { useState } from "react";
import { Constants } from "../../../../../common/constants";
import { DashboardUtils } from "../../dashboard_utils";
import { TextAreaForm } from "../text_area";

interface DescriptionFieldProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	disabled?: boolean;
}

export function DescriptionField(props: DescriptionFieldProps) {
	const [isExpanded, setIsExpanded] = useState(Boolean(props.value));

	return (
		<div className="field description-field">
			{!isExpanded ? (
				<button
					type="button"
					className="button is-text add-field-button"
					onClick={() => setIsExpanded(true)}
					disabled={props.disabled}
				>
					<span className="icon">
						<i className="fas fa-align-left"></i>
					</span>
					<span className="add-field-text">Add Description</span>
				</button>
			) : (
				<>
					{DashboardUtils.CreateHeaderAndInfoButton(
						<span className="field-header-with-icon">
							<i className="fas fa-align-left"></i>
							Description
						</span>,
						"",
						false,
						false,
						false,
						undefined,
						props.disabled
					)}
					<TextAreaForm
						initial_value={props.value}
						rows={6}
						placeholder={props.placeholder}
						updateFunc={props.onChange}
						char_limit={Constants.DESCRIPTION_CHAR_LIMIT}
						do_not_clear_on_unmount
					/>
				</>
			)}
		</div>
	);
}
